// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  //apiUrl: 'http://localhost:22900/api/',
  apiUrl: 'https://api.servispozitif.com/api/',
  kurumid : 13182,
  production: true,
  isontalepgoster : true,
  istalepgoster : false,
  logo : "https://narpos.com.tr/img/logo.png",
  footer1:"teknikdestek@narpos.com.tr - NarPOS Yazılım Tic. A.Ş..",
  footer2:"Whatsapp Destek: +0 212 909 48 89"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
